import { defineNuxtPlugin, useRouter, useRuntimeConfig } from "nuxt/app";
import type { RouteLocationNormalizedLoaded } from "vue-router";
import { initializeMetaPixel, trackMetaEvent } from "~/utils/metaPixel";

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const router = useRouter();
  const analytics = useAnalytics();
  const metaPixelId = String(config.public.META_PIXEL_ID || "");
  let lastTrackedPath = "";

  initializeMetaPixel(metaPixelId);

  const trackPageView = (route: RouteLocationNormalizedLoaded) => {
    if (route.fullPath === lastTrackedPath) return;
    lastTrackedPath = route.fullPath;

    analytics.push("page_view", {
      page_path: route.path,
      page_title: document.title
    });
    trackMetaEvent("PageView");
  };

  router.afterEach((to) => trackPageView(to));
  nuxtApp.hook("app:mounted", () => trackPageView(router.currentRoute.value));
});
